import { BadgeCheckIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useUnitDiscountSuspenseQuery } from '@/api/accommodation/hooks'
import type { AccommodationDetail } from '@/api/accommodation/types'
import Price from '@/components/money/price'
import { trackPriceGuaranteeOpened, trackReservationCalendarOpened } from '@/lib/track'
import { buildComparison, getSitesWithPrice } from '../price-guarantee/comparison'

interface DateSelectionBottomBarProps {
  accommodation: AccommodationDetail
  onOpenSheet: () => void
  onOpenGuarantee: () => void
}

export const DateSelectionBottomBar = ({
  accommodation,
  onOpenSheet,
  onOpenGuarantee,
}: DateSelectionBottomBarProps) => {
  const { discount } = useUnitDiscountSuspenseQuery(accommodation.unit.id)

  const trackCalendarOpened = () => {
    const prices = {
      dailyStandardPriceFrom: discount?.maxPrice,
      dailyDiscountPriceFrom: discount?.minPrice,
    }
    trackReservationCalendarOpened(accommodation, prices)
  }

  const handleOpenSheet = () => {
    trackCalendarOpened()
    onOpenSheet()
  }

  const handleOpenGuarantee = () => {
    trackCalendarOpened()
    if (discount) {
      trackPriceGuaranteeOpened(accommodation, buildComparison(discount, getSitesWithPrice(accommodation)))
    }
    onOpenGuarantee()
  }

  return (
    <div className="space-y-1">
      <div className="flex items-center gap-6">
        {discount && (
          <div className="flex flex-1 flex-col gap-1">
            <div className="text-xl font-semibold text-slate-900">
              od <Price price={discount.minPrice} /> / noc
            </div>
            {discount.maxPrice > discount.minPrice && (
              <div className="text-sm text-slate-400">
                <Price price={discount.maxPrice} className="line-through" /> / noc
              </div>
            )}
            <button
              type="button"
              onClick={handleOpenGuarantee}
              className="flex items-center gap-1 text-xs font-medium text-green-700"
            >
              <BadgeCheckIcon className="size-3.5 shrink-0" />
              <span className="underline underline-offset-2">Garance nejlepší ceny</span>
            </button>
          </div>
        )}
        <Button onClick={handleOpenSheet} size="lg">
          Vybrat termín
        </Button>
      </div>
    </div>
  )
}

export const DateSelectionBottomBarSkeleton = () => {
  return (
    <div className="flex items-center gap-6">
      <div className="flex flex-1 flex-col gap-1">
        <div className="h-6 w-32 animate-pulse rounded bg-slate-200" />
        <div className="h-4 w-20 animate-pulse rounded bg-slate-100" />
      </div>
      <Button disabled>Vybrat termín</Button>
    </div>
  )
}
